import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Modal, Field, Input, Textarea, Checkbox, Btn } from "@kit-v5";
function DeclarativeBody({ args, onAction }) {
    const [fieldValues, setFieldValues] = React.useState(() => {
        const init = {};
        for (const f of args.fields ?? []) {
            init[f.id] = f.initial !== undefined ? f.initial : (f.kind === "checkbox" ? false : "");
        }
        return init;
    });
    function handleAction(id) {
        if (args.fields && args.fields.length > 0)
            onAction(id, fieldValues);
        else
            onAction(id);
    }
    return (_jsxs(_Fragment, { children: [args.body && _jsx("p", { style: { whiteSpace: "pre-wrap", margin: "0 0 16px", fontSize: 13 }, children: args.body }), (args.fields ?? []).map((f) => (_jsx(Field, { label: f.label, required: f.required, children: f.kind === "checkbox" ? (_jsx(Checkbox, { checked: fieldValues[f.id], onChange: (checked) => setFieldValues((v) => ({ ...v, [f.id]: checked })) })) : f.kind === "textarea" ? (_jsx(Textarea, { value: fieldValues[f.id], onChange: (value) => setFieldValues((v) => ({ ...v, [f.id]: value })) })) : (_jsx(Input, { value: fieldValues[f.id], onChange: (value) => setFieldValues((v) => ({ ...v, [f.id]: value })) })) }, f.id))), _jsx("div", { style: { display: "flex", gap: 8, justifyContent: "flex-end" }, children: args.actions.map((a) => (_jsx(Btn, { kind: a.variant ?? "secondary", onClick: () => handleAction(a.id), children: a.label }, a.id))) })] }));
}
export default function ModalOverlay({ state, onClose }) {
    if (!state)
        return null;
    return (_jsx(Modal, { open: true, onClose: () => onClose(null), title: state.args.title, size: state.args.size ?? "sm", closeOnBackdrop: true, closeOnEsc: true, children: _jsx(DeclarativeBody, { args: state.args, onAction: (actionId, values) => onClose({ actionId: actionId ?? null, values }) }) }));
}
